import e from"./InfiniteHits.vue_vue&type=script&lang.js";import{render as t}from"./InfiniteHits.vue_vue&type=template&id=dcfb64b8&lang.js";e.render=t,e.__file="src/components/InfiniteHits.vue";export default e;
//# sourceMappingURL=InfiniteHits.vue.js.map
